<input type="text" value="" class="heightzero" #clipboardInput>
<div class="tabcontainer">
  <div class="searchBlock">
    <div class="searchSection">
      <i class="icon-search"></i>
      <div class="searchtxt">
        <input #listingInput id="searchInputBox"class="search-components textBox" type="text" [placeholder]="placeholder" [(ngModel)]="str"
          (keydown)="onKeydown($event, listingInput)" (focus)="searchFocus = true" (focusout)="searchFocus = false"
          autofocus />
          <ng-container *ngIf="listSuggestionArray && listSuggestionArray.length > 0">
            <div [ngClass]="(showSuggestionBox) ? 'block' : '' " class="autosuggestion" *ngIf="listSuggestionArray">
              <ul>
                <ng-container *ngFor="let item of listSuggestionArray; let i = index ; trackBy: trackByName; ">
                  <li [class.active]="i == arrowkeyLocation">
                    <span class="name" (click)="getsearchResults(item)">{{item}}</span>
                  </li>
                </ng-container>
              </ul>
            </div>
          </ng-container>
      </div>
    </div>
    <div class="filterSection spImg">
      <!-- <i class="icon-filter"></i> -->
      <!-- <div class="fliterBlock">
        <div class="searchfilter">
          <span [class]="exactMatch ? 'exact green' : 'exact'" (click)="toggleSwitch('exact')" tabindex="0"
            (keydown)="callToggles($event, 'exact')" id="searchFilter">
            Exact & Latest
          </span>
        </div>
        <ul class="filterOption">
          <ng-container *ngIf="filterList && facets">
            <ng-container *ngFor="let filter of filterList;let i = index">
              <li [class]="(i <= 3) ? 'togfilt block' : (i > 3 && showMore) ? 'togfilt block' : 'togfilt none'">
                <filter [filterType]="filter.type" [displayName]="filter.name"
                  [data]="getFilterData(filter.facet_name_meta)" [facetName]="filter.facet_name"
                  [facetNameMeta]="filter.facet_name_meta" [isDataKeyValuePair]="filter.isDataKeyValuePair"
                  [filterId]="filter.filter_id" (filterSelect)="urlUpdate($event)"></filter>
              </li>
              <span #moreButtonEl tabindex="0"
                [class]="(checkFocusInside(moreButtonEl) ? (showMore ? 'morefilterdrop spImg less focused' : 'morefilterdrop spImg more focused') : (showMore ? 'morefilterdrop spImg less' : 'morefilterdrop spImg more'))"
                (click)="(showMore = !showMore)"
                *ngIf="(filterList.length > 4 ) && i === 3">{{(showMore) ? 'less' : 'more'}}</span>
            </ng-container>
          </ng-container>
        </ul>
      </div> -->
    </div>
    <!-- <div class="closebg"></div> -->
  </div>

  <div class="storyMobScroll mainMircosite">
  <div class="headingsList customMicrosite">
    <ul>
      <ng-container *ngFor="let header of headerList">
        <li [class]="header.class">{{header.name}}</li>
      </ng-container>
    </ul>
  </div>
  <div class="contentList">
    <ng-template #loading>
      <div style="text-align: center; display: inline-block; width: 100%;">
        <ng-container *ngIf="callFail">
          <div style="text-align: center; display: inline-block; width: 100%; padding-top:200px;">
            Sorry, Server Error
          </div>
        </ng-container>
        <ng-container *ngIf="!callFail">
          <div class="imagepreloader">
            <div class="a" style="--n: 5;">
              <div class="dot dot1" style="--i: 0;"></div>
              <div class="dot dot2" style="--i: 1;"></div>
              <div class="dot dot3" style="--i: 2;"></div>
              <div class="dot dot4" style="--i: 3;"></div>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-template>

    <ng-template #nores>
      <div style="text-align: center; display: inline-block; width: 100%; padding-top:200px;">No Data</div>
    </ng-template>
    <ng-container *ngIf="noresults == false;then listData else nores"></ng-container>
    <ng-template #listData>
      <ng-container *ngIf="listArray.length > 0;else loading">
        <ng-container [ngSwitch]="pageId">
          <ng-container *ngSwitchCase="'micrositeList'">
            <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
              <ul #listEl tabindex="0" class="locked rssfeedul micrositeContent" #listData2>
                <a #listEl tabindex="0"
                [routerLink]="'/dash/microsite/' + item.id"
                >
                <li (click)="openPreview(item)" class="headline" [title]="item.name">
                  <div class="relhidden">
                    <div class="listCell" [innerHTML]="item.name"></div>
                  </div>
                </li>

                <li (click)="openPreview(item)" class="agency">
                  <div class="relhidden">
                    <div class="listCell">{{item.url}}</div>
                  </div>
                </li>

                <li (click)="openPreview(item)" class="section" [title]="item.pageCount">
                  <div class="relhidden">
                    <div class="listCell">{{item.pageCount ? item.pageCount : 'null'}}</div>
                  </div>
                </li>

                <li (click)="openPreview(item)" class="status" [title]="item.updatedBy">
                  <div class="relhidden">
                    <div class="listCell">{{item.updatedByUserName ? item.updatedByUserName : item.updatedBy}}</div>
                  </div>
                </li>

                <li (click)="openPreview(item)" class="receivedAt">
                  <div class="relhidden">
                    <div class="listCell">{{(displayLastUpdated(item.modificationHistory))}}</div>
                  </div>
                </li>

                <li (click)="openPreview(item)" class="section">
                  <div class="relhidden">
                    <div [class]="item.status && item.status==='PUBLISHED' ? 'listCell published' : 'listCell created'" >{{(item.status ? item.status : 'CREATED')}}</div>
                  </div>
                </li>
                </a>
              

              </ul>
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'templateList'">
            <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
              <ul #listEl tabindex="0" class="locked rssfeedul micrositeContent" #listData2>

                <li (click)="openPreviewTemplate(item)" class="headline" [title]="item.headline">
                  <div class="relhidden">
                    <div class="listCell" [innerHTML]="item.name"></div>
                  </div>
                </li>

                <li (click)="openPreviewTemplate(item)" class="section" [title]="item.section">
                  <div class="relhidden">
                    <div class="listCell">{{item.pageCount}}</div>
                  </div>
                </li>

                <li (click)="openPreviewTemplate(item)" class="status" [title]="item.status">
                  <div class="relhidden">
                    <div class="listCell">{{item.lockedByUserName}}</div>
                  </div>
                </li>

                <li (click)="openPreviewTemplate(item)" class="receivedAt">
                  <div class="relhidden">
                    <div class="listCell">{{getNewTypeDateNew(item.updateDate)}}</div>
                  </div>
                </li>


              </ul>
            </ng-container>
          </ng-container>

        </ng-container>

      </ng-container>
    </ng-template>
  </div>
  </div>



  <div class="footerPagination">
    <div class="pagination" *ngIf="totalRecords > 50">Page
      <ul>
        <ng-container *ngIf="7 > pages">
          <ng-container *ngFor="let j of arrayOne(pages); let i = index">
            <!-- <ng-container *ngIf="i >= (pageNum - 3) && (pageNum + 3) > i && pages > (i+1)"> -->
            <li [class]="pageNum == i ? 'active' : ''" (click)="onPageNumberChange(i)">{{(i + 1)}}</li>
            <!-- </ng-container> -->
          </ng-container>
        </ng-container>
        <ng-container *ngIf="pages > 6">
          <ng-container *ngFor="let j of arrayOne(pages); let i = index">
            <ng-container *ngIf="i >= (pageNum - 3) && (pageNum + 3) > i && pages > (i+1)">
              <li [class]="pageNum == i ? 'active' : ''" (click)="onPageNumberChange(i)">{{(i + 1)}}</li>
            </ng-container>
          </ng-container>
          <li>..</li>
          <li [class]="pageNum == (pages-1) ? 'active' : ''" (click)="onPageNumberChange(pages - 1)">{{(pages)}}</li>
        </ng-container>
      </ul>
    </div>

    <ng-container *ngIf="totalRecords < 50;then displayPaging else showPaging"></ng-container>
    <ng-template #showPaging>
      <div class="recordList">Showing
        <select name="recordList" class="select-wrapper" [(ngModel)]="pageSize"
          (ngModelChange)="onPageSizeChange($event)">
          <option *ngFor="let c of pageSizeArray" [ngValue]="c"> {{c}} </option>
        </select>results of {{totalRecords}}
      </div>
    </ng-template>
    <ng-template #displayPaging>
      <div id="dropDownRecordListInPagination" class="recordList borderNone">
        Showing {{totalRecords}} results</div>
    </ng-template>
  </div>
</div>




<ng-container *ngIf="openCreateTemplateFlag">
  <div class="lightBox sendNotifications" style="display:block;">
    <div class="notificationWindow">
      <div class="unlockStory">
        <div class="wid100 pad30">
          <div class="headerBlock" id="sendNotificationButton">
          <h3 class="flSendNoti">Edit Template</h3>

        </div>
          <div class="salesReport">
            <div class="sendNotificationBlock">
            <div class="sendNotification" *ngIf="template">

                <ul class="twoLi">
                    <li [class]="mandatoryFieldMessage ? 'errorInput' : ''">
                        <label for="title" class="control-label">Template Name</label>
                        <input id="title" type="text" class="form-control" [(ngModel)]="template.name">
                    </li>
                </ul>
                <ul class="twoLi" >
                    <li>
                      <label for="count" class="control-label">Page Count</label>
                      <input id="count" name="count" type="number"  min="0" max="99"(change)="changePageCount()"[(ngModel)]="template.pageCount">
                    </li>
                </ul>
                
                  <ng-container *ngIf="!template.pageCount">
                    <label for="count" class="control-label">Page Content Template (* Enter page count to select Templates) </label>
                  </ng-container>
                  <ng-container *ngIf="template.pageCount">
                    <ng-container *ngFor="let item of [].constructor(template.pageCount) ; let i = index">
                      <ul class="twoLi" >
                        <li>
                          <label for="count" class="control-label">Page {{i+1}} Content Template</label>
                          <div class="dataField">
                            <tags-creator [autoSuggest]="true" [autocompletelist]="elementList" (focusoutfn)="disableInnerFocus($event)" [noMinReq]="true"
                              [data]="template.pageContentTemplate[i]" [setFocus]="innerFocusFlag"
                              [displayText]="'Choose Page elements here..'" (clickfn)="customFunc($event)" (changefn)="template.pageContentTemplate[i] = $event"
                              (focusedfn)="catchTagFocus($event)"></tags-creator>
                          </div>
                        </li>
                      </ul>
                    </ng-container>
                  </ng-container>
                  

            </div>
        </div>
          </div>
        </div>
        <div class="fr wid100 right padlr30 ptb15">
          <button class="cancel gray ml10" name="cancel"
            (click)="closeTemplate()" type="button">Cancel</button>
          <button class="add blue ml10 " name="send" type="button" (click)="saveTemplate(template.id)">Save</button>
        </div>
      </div>
    </div>
  </div>
</ng-container>


<div class="loaderimage block" *ngIf="showLoader">
  <div class="imagepreloader">
    <!-- <h3>TRANSLATING...</h3> -->
    <div class="a" style="--n: 5;">
      <div class="dot dot1" style="--i: 0;"></div>
      <div class="dot dot2" style="--i: 1;"></div>
      <div class="dot dot3" style="--i: 2;"></div>
      <div class="dot dot4" style="--i: 3;"></div>
    </div>
  </div>
</div>
